import Index from '@/pages/vns/Index'
import Form from '@/pages/vns/Form'
import MonitoringIndex from '@/pages/vns/monitoring/Index'
import Detail from '@/pages/vns/monitoring/Detail'
import ShowVns from "@/pages/vns/monitoring/Show";
import PermissionIndex from '@/pages/vns/permissions/Index'
import PermissionForm from '@/pages/vns/permissions/UpdatePermission'
import StateIndex from '@/pages/vns/states/Index'
import StateForm from '@/pages/vns/states/Form'
import ManufacturerIndex from '@/pages/vns/manufacturers/Index'
import ManufacturerForm from '@/pages/vns/manufacturers/Form'
import ProtocolIndex from '@/pages/vns/protocols/Index'
import ProtocolForm from '@/pages/vns/protocols/Form'
import FileformatIndex from '@/pages/vns/fileformats/Index'
import FileformatForm from '@/pages/vns/fileformats/Form'
import IntegrationIndex from '@/pages/vns/integrations/Index'
import IntegrationForm from '@/pages/vns/integrations/Form'
import IntegrationHelperIndex from '@/pages/vns/integrationHelper/Index'
import IntegrationHelperForm from '@/pages/vns/integrationHelper/Form'
import CredentialIndex from '@/pages/vns/credentials/Index'
import CredentialForm from '@/pages/vns/credentials/Form'
import AttributeIndex from '@/pages/vns/attribute/Index'
import AttributeForm from '@/pages/vns/attribute/Form'

import RangesIndex from '@/pages/vns/ranges/Index'
import RangesForm from '@/pages/vns/ranges/Form'

import Observation from '@/pages/vns/observation/Observation'
import ObservationSupport from '@/pages/vns/observation/ObservationSupport'
import ObservationLis from '@/pages/vns/observation/ObservationLis'

import ProtocolSettingsIndex from '@/pages/vns/protocolSettings/Index'
import ProtocolSettingsForm from '@/pages/vns/protocolSettings/Form'
import EditTree from "@/pages/vns/EditTree";

import ServiceQueueIndex from '@/pages/vns/serviceQueue/Index'

import ReportTrashIndex from '@/pages/vns/reportTrash/Index'
import ReportTrashForm from '@/pages/vns/reportTrash/Form'

import ReportControlIndex from '@/pages/vns/reportControl/Index'
import ReportControlForm from '@/pages/vns/reportControl/Form'

import ReportEditableIndex from '@/pages/vns/reportEditable/Index'
import ReportEditableForm from '@/pages/vns/reportEditable/Form'

const VnsRoutes = [
    {path: '/vns', name: 'vns.index', component: Index, meta: {permission: 'vns.index'}},
    {path: '/vns/create', name: 'vns.create', component: Form, meta: {permission: 'vns.create'}},
    {path: '/vns/edit/:id', name: 'vns.edit', component: Form, meta: {permission: 'vns.edit'}},
    {path: '/vns/show/:id', name: 'vns.show', component: ShowVns},

    {path: '/monitoring/order/observation', name: 'monitoring.order.observation', component: Observation, meta: {permission: 'vns_monitor.observation'}},
    {path: '/monitoring/order/observation/support', name: 'monitoring.order.observation_support', component: ObservationSupport, meta: {permission: 'vns_monitor.observation_support'}},
    {path: '/monitoring/order/observation/lis', name: 'monitoring.order.observation_lis', component: ObservationLis, meta: {permission: 'vns_monitor.observation_lis'}},

    {path: '/vns/monitoring', name: 'vns.monitoring', component: MonitoringIndex, meta: {permission: 'vns_monitor.tipo'}},
    {path: '/vns/monitoring/detail', name: 'vns.monitoring.details', component: Detail, meta: {permission: 'vns_monitor.tipo'}},

    {path: '/vns/service_queue', name: 'vns.service_queue', component: ServiceQueueIndex, meta: {permission: 'vns_monitor.service_queue'}},

    {path: '/vns/permissions/list', name: 'vns.permissions.index', component: PermissionIndex},
    {path: '/vns/permissions/edit/:id', name: 'vns.permissions.edit', component: PermissionForm},

    {path: '/vns/ranges', name: 'vns.ranges', component: RangesIndex, meta: {permission: 'ranges.index'}},
    {path: '/vns/ranges/create', name: 'vns.ranges.create', component: RangesForm, meta: {permission: 'ranges.create'}},
    {path: '/vns/ranges/edit/:id', name: 'vns.ranges.edit', component: RangesForm, meta: {permission: 'ranges.edit'}},

    {path: '/vns/states', name: 'vns.states', component: StateIndex, meta: {permission: 'states.index'}},
    {path: '/vns/states/create', name: 'vns.states.create', component: StateForm, meta: {permission: 'states.create'}},
    {path: '/vns/states/edit/:id', name: 'vns.states.edit', component: StateForm, meta: {permission: 'states.edit'}},

    {path: '/vns/manufacturer', name: 'vns.manufacturer', component: ManufacturerIndex, meta: {permission: 'manufactures.index'}},
    {path: '/vns/manufacturer/create', name: 'vns.manufacturer.create', component: ManufacturerForm, meta: {permission: 'manufactures.create'}},
    {path: '/vns/manufacturer/edit/:id', name: 'vns.manufacturer.edit', component: ManufacturerForm, meta: {permission: 'manufactures.edit'}},

    {path: '/vns/protocol', name: 'vns.protocol', component: ProtocolIndex, meta: {permission: 'protocols.index'}},
    {path: '/vns/protocol/create', name: 'vns.protocol.create', component: ProtocolForm, meta: {permission: 'protocols.create'}},
    {path: '/vns/protocol/edit/:id', name: 'vns.protocol.edit', component: ProtocolForm, meta: {permission: 'protocols.edit'}},

    {path: '/vns/fileformat', name: 'vns.fileformat', component: FileformatIndex, meta: {permission: 'fileformats.index'}},
    {path: '/vns/fileformat/create', name: 'vns.fileformat.create', component: FileformatForm, meta: {permission: 'fileformats.create'}},
    {path: '/vns/fileformat/edit/:id', name: 'vns.fileformat.edit', component: FileformatForm, meta: {permission: 'fileformats.edit'}},

    {path: '/vns/integration', name: 'vns.integration', component: IntegrationIndex, meta: {permission: 'integrations.index'}},
    {path: '/vns/integration/create', name: 'vns.integration.create', component: IntegrationForm, meta: {permission: 'integrations.create'}},
    {path: '/vns/integration/edit/:id', name: 'vns.integration.edit', component: IntegrationForm, meta: {permission: 'integrations.edit'}},

    // TODO: Corrigir Permissoes
    {path: '/vns/integration_helper', name: 'vns.integration_helper', component: IntegrationHelperIndex, meta: {permission: 'integrations.index'}},
    {path: '/vns/integration_helper/create', name: 'vns.integration_helper.create', component: IntegrationHelperForm, meta: {permission: 'integrations.create'}},
    {path: '/vns/integration_helper/edit/:id', name: 'vns.integration_helper.edit', component: IntegrationHelperForm, meta: {permission: 'integrations.edit'}},

    {path: '/vns/credential', name: 'vns.credential', component: CredentialIndex, meta: {permission: 'credentials.index'}},
    {path: '/vns/credential/create', name: 'vns.credential.create', component: CredentialForm, meta: {permission: 'credentials.create'}},
    {path: '/vns/credential/edit/:id', name: 'vns.credential.edit', component: CredentialForm, meta: {permission: 'credentials.edit'}},

    {path: '/vns/attribute', name: 'vns.attribute', component: AttributeIndex, meta: {permission: 'attributes.index'}},
    {path: '/vns/attribute/create', name: 'vns.attribute.create', component: AttributeForm, meta: {permission: 'attributes.create'}},
    {path: '/vns/attribute/edit/:id', name: 'vns.attribute.edit', component: AttributeForm, meta: {permission: 'attributes.edit'}},

    {path: '/vns/protocol_settings', name: 'vns.protocol_settings', component: ProtocolSettingsIndex, meta: {permission: 'protocols.index'}},
    {path: '/vns/protocol_settings/create', name: 'vns.protocol_settings.create', component: ProtocolSettingsForm, meta: {permission: 'protocols.create'}},
    {path: '/vns/protocol_settings/edit/:id', name: 'vns.protocol_settings.edit', component: ProtocolSettingsForm, meta: {permission: 'protocols.edit'}},

    {path: '/vns/tree', name: 'vns.tree', component: EditTree, meta: {permission: 'vns.index'}},

    {path: '/vns/report_trash', name: 'vns.report_trash', component: ReportTrashIndex, meta: {permission: 'report_trash.index'}},
    {path: '/vns/report_trash/edit/:id', name: 'vns.report_trash.edit', component: ReportTrashForm, meta: {permission: 'report_trash.edit'}},

    {path: '/vns/report_control', name: 'vns.report_control', component: ReportControlIndex, meta: {permission: 'report_control.index'}},
    {path: '/vns/report_control/edit/:id', name: 'vns.report_control.edit', component: ReportControlForm, meta: {permission: 'report_control.edit'}},

    {path: '/vns/report_editable', name: 'vns.report_editable', component: ReportEditableIndex, meta: {permission: 'report_editable.index'}},
    {path: '/vns/report_editable/edit/:id', name: 'vns.report_editable.edit', component: ReportEditableForm, meta: {permission: 'report_editable.edit'}},
]

export default VnsRoutes;